module.exports = __webpack_public_path__ + "img/ANTENNA 2 RED.9c96c23.svg";